export const getContentEnv = () => {
  let params: Record<string, string> = {};
  if (typeof window !== 'undefined') {
    const urlSearchParams = new URLSearchParams(window.location.search);
    params = Object.fromEntries(urlSearchParams.entries());
  }
  return params.contentEnv || process.env.REACT_APP_CONTENT_ENV || 'prod';
};

const tutoringApiUrl = () => {
  switch (getContentEnv()) {
    case 'prod':
      return 'https://api.tutoring-prd.pearsonprd.tech';
    case 'stage':
      return 'https://api.tutoring-stg.pearsondev.tech';
    default:
      return 'https://api.tutoring-dev.pearsondev.tech';
  }
};

export const getTutorWeeklySessionsByStartEndDate = async (
  // tutorId: string, // IES id
  from: string,
  to: string,
  offset: number,
  token: string,
) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ from, to, offset }),
  };

  try {
    const group = await fetch(`${tutoringApiUrl()}/tutors/getWeeklySessions`, requestOptions);
    return await group.json();
  } catch (e) {
    console.log('error:', e);
    return undefined;
  }
};

export const getTutorByIesId = async (
  // iesId: string, // IES id
  token: string,
) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const resp = await fetch(`${tutoringApiUrl()}/tutors/getTutor`, requestOptions);
    return await resp.json();
  } catch (e) {
    console.log('error:', e);
    return undefined;
  }
};
